import { useState, useRef, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./buy.css";
import { config } from "../../Environment";
import useRetryFetch from "../../hooks/useRetryFetch";
import { useEffectOnce } from "../../hooks/useEffectOnce";
import { PaymentIframe } from "../payment/PaymentIframe";
import { toast } from "sonner";

import { Spinner } from "../ui/spinner";

function Buy() {
  const navigate = useNavigate();
  const retryFetch = useRetryFetch();

  const location = useLocation();
  const acceptId = location.state?.acceptId;

  const query = new URLSearchParams(location.search);
  const productId = query.get('productId');

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [showPaymentIframe, setShowPaymentIframe] = useState(false);

  async function startPayment() {
    setLoading(true);
    const response = await retryFetch(`${config.API_BASE}/api/payment/start`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          productId,
          useIframe: true,
        }),
    });
    if (response.ok) {
      const result = await response.json();
      if (result.type === 'redirect') {
        console.log(`Opening payment in iframe: ${result.redirect}`);
        setPaymentUrl(result.redirect);
        setShowPaymentIframe(true);
        setLoading(false);
      }
    } else {
      toast.error(t("payment_initialization_failed") || "Failed to initialize payment");
      setLoading(false);
    }
  }

  useEffectOnce(() => {
    startPayment();
  }, []);

  function handlePaymentSuccess() {
    // Payment success is now handled by PaymentIframe component
    // It will show action buttons and user can choose what to do
    // No forced redirect - user stays on current page or chooses action
    console.log("Payment successful - handled by PaymentIframe");
  }

  function handlePaymentError(error) {
    toast.error(error || t("payment_failed") || "Payment failed");
    setShowPaymentIframe(false);
    // Navigate back to marketplace on error
    navigate("/marketplace");
  }

  function handlePaymentClose() {
    setShowPaymentIframe(false);
    // Go back to previous page or marketplace
    if (window.history.length > 1) {
      navigate(-1); // Go back to where they came from
    } else {
      navigate("/marketplace");
    }
  }

  function renderLoadingImage() {
    if (loading) {
      return (
        <Spinner size="md" />
      );
    } else {
      return (<></>);
    }
  }

  return (
    <>
      <div className="h-full w-full flex items-center justify-start py-12">
        <div className="mx-auto grid w-[350px] gap-6">
          {renderLoadingImage()}
          <div className="grid gap-2 text-center">
            <h1 className="text-3xl font-bold">{t("loading")}</h1>
            {/* <p style={{fontSize: "0.8em", color: "#555555"}}>{productId}</p> */}
          </div>
        </div>
      </div>

      <PaymentIframe
        open={showPaymentIframe}
        paymentUrl={paymentUrl}
        onSuccess={handlePaymentSuccess}
        onError={handlePaymentError}
        onClose={handlePaymentClose}
      />
    </>
  );
}

export default Buy;
